
import { Component, Input } from "@angular/core";
import { RouterModule } from "@angular/router";

@Component({
    selector: "app-section-header",
    imports: [RouterModule],
    templateUrl: "./section-header.component.html",
    styleUrl: "./section-header.component.scss"
})
export class SectionHeaderComponent {
  @Input({ required: true }) title = "";
  @Input() urlPath?: string;
  @Input() urlText?: string = "VER TODOS";
}
